module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-dashboard",
    attrs: {
      "id": "home"
    }
  }, [_c('calendar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.calendarDisp || _vm.pcDisp),
      expression: "calendarDisp || pcDisp"
    }],
    attrs: {
      "pcDisp": _vm.pcDisp
    }
  }), _vm._v(" "), _c('div', {
    class: {
      'twin-row': _vm.pcDisp
    }
  }, [_c('warningmsg', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.warningmsgDisp || _vm.pcDisp),
      expression: "warningmsgDisp || pcDisp"
    }],
    attrs: {
      "pcDisp": _vm.pcDisp,
      "triggerWarningmsgInfiniteBool": _vm.triggerWarningmsgInfiniteBool
    }
  }), _vm._v(" "), _c('knowledge', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.knowledgeDisp || _vm.pcDisp),
      expression: "knowledgeDisp || pcDisp"
    }],
    attrs: {
      "pcDisp": _vm.pcDisp,
      "triggerKnowledgeInfiniteBool": _vm.triggerKnowledgeInfiniteBool
    }
  })], 1), _vm._v(" "), _c('contact', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.contactDisp || _vm.pcDisp),
      expression: "contactDisp || pcDisp"
    }],
    attrs: {
      "pcDisp": _vm.pcDisp,
      "triggerContactInfiniteBool": _vm.triggerContactInfiniteBool
    }
  }), _vm._v(" "), _c('poll', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pollDisp || _vm.pcDisp),
      expression: "pollDisp || pcDisp"
    }],
    attrs: {
      "pcDisp": _vm.pcDisp,
      "triggerPollInfiniteBool": _vm.triggerPollInfiniteBool
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.pcDisp),
      expression: "!pcDisp"
    }],
    staticClass: "icon-bar dash-bg-color-skin"
  }, [_c('a', {
    class: {
      'nav-active': _vm.calendarDisp
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleDashboard('calendarDisp')
      }
    }
  }, [_c('div', {
    staticClass: "tri dash-border-bottom-color-skin-dark-30"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-calendar"
  }), _vm._v(" "), _c('div', {
    staticClass: "icon-text"
  }, [_vm._v("Activity")])]), _vm._v(" "), _c('a', {
    class: {
      'nav-active': _vm.warningmsgDisp
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleDashboard('warningmsgDisp')
      }
    }
  }, [_c('div', {
    staticClass: "tri dash-border-bottom-color-skin-dark-30"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-warning "
  }), _vm._v(" "), _c('div', {
    staticClass: "icon-text"
  }, [_vm._v("warning")])]), _vm._v(" "), _c('a', {
    class: {
      'nav-active': _vm.contactDisp
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleDashboard('contactDisp')
      }
    }
  }, [_c('div', {
    staticClass: "tri dash-border-bottom-color-skin-dark-30"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-address-card"
  }), _vm._v(" "), _c('div', {
    staticClass: "icon-text"
  }, [_vm._v("Contact")])]), _vm._v(" "), _c('a', {
    class: {
      'nav-active': _vm.knowledgeDisp
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleDashboard('knowledgeDisp')
      }
    }
  }, [_c('div', {
    staticClass: "tri dash-border-bottom-color-skin-dark-30"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-newspaper-o"
  }), _vm._v(" "), _c('div', {
    staticClass: "icon-text"
  }, [_vm._v("Knowledge")])]), _vm._v(" "), _c('a', {
    class: {
      'nav-active': _vm.pollDisp
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleDashboard('pollDisp')
      }
    }
  }, [_c('div', {
    staticClass: "tri dash-border-bottom-color-skin-dark-30"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-align-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "icon-text"
  }, [_vm._v("Poll")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2c413378!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/component.vue
// module id = 3649
// module chunks = 1